import React, {useEffect} from 'react'

const Clients = () => {
useEffect(()=>{
document.title = 'Regulatory Compliance | RAK ENGINEERING LTD';

},[]);



  return (
    <>
    <section className='section-cover clients-cover' >
          <h2 className="home-h2">Regulatory Compliance</h2>
          <p className='clients-para'><strong>RAK ENGINEERING LTD</strong> is a duly incorporated company. We are also registered with Public Procurement and Disposal of Public Assets (PPDA) and Petroleum Authority of Uganda (PAU) as per the certifications below:</p>
       
       
       
        {/* <div className='content-container clients'>

           <article className='client'>
                      <img src='./images/MTN.jpg' alt='client' className='client-image'></img>
           </article>

          </div>  */}
    </section>
    {/* <section className='section-cover certifications-cover' >
      <div className='all-certs'>
        <img src='images/9001.jpg' className='certification-image'></img>
 <img src='images/14001.jpg' className='certification-image'></img>
 <img src='images/45001.jpg' className='certification-image'></img>
    </div>
    </section> */}
    <section className="cert-cover">
    
        <div>
          <img src='images/COI.jpg' className='certification-image'></img>
        </div>

         <div>
          <img src='images/PPDA.jpg' className='certification-image'></img>
        </div>

         <div>
          <img src='images/PAU.jpg' className='certification-image'></img>
        </div>

        <div>
          <img src='images/TL.jpg' className='certification-image'></img>
        </div>



    </section>
    </>
  )
}

export default Clients